// import React, { useState, useEffect } from "react";
// import { MdBorderHorizontal } from "react-icons/md";
// import PropTypes from "prop-types";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
// import { toast } from "sonner";

// const JobSeekerSearch = () => {
//   const [searchQuery, setSearchQuery] = useState("");
//   const [jobSeekers, setJobSeekers] = useState([]);
//   const [selectedJobSeeker, setSelectedJobSeeker] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [isDownloading, setIsDownloading] = useState(false);
//   const [jobOffers, setJobOffers] = useState([]);
//   const [isJobOfferModalOpen, setIsJobOfferModalOpen] = useState(false);
//   const [formData, setFormData] = useState({
//     searcherName: "",
//     jobSeekerUniqueId: "",
//     searchReason: "",
//     email: "",
//   });
//   const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
//   const [paymentStatus, setPaymentStatus] = useState(null);

//   // Download button
//   const handleDownloadPDF = async () => {
//     setIsDownloading(true);
//     try {
//       const modalContent = document.querySelector("#job-seeker-modal");
//       if (!modalContent) {
//         toast.error("Error: Modal content not found.");
//         return;
//       }

//       // Temporarily remove max-height and overflow to capture all content
//       const originalStyle = modalContent.style.cssText;
//       modalContent.style.maxHeight = "none";
//       modalContent.style.overflow = "visible";

//       const canvas = await html2canvas(modalContent, {
//         scale: 2, // Higher resolution for clarity
//         useCORS: true, // Handle cross-origin resources
//         backgroundColor: "#ffffff", // Match modal background
//         windowWidth: modalContent.scrollWidth, // Capture full width
//         windowHeight: modalContent.scrollHeight, // Capture full height
//       });

//       // Restore original styles
//       modalContent.style.cssText = originalStyle;

//       const imgData = canvas.toDataURL("image/png");
//       const pdf = new jsPDF({
//         orientation: "portrait",
//         unit: "px",
//         format: "a4",
//       });

//       const pdfWidth = pdf.internal.pageSize.getWidth();
//       const pdfHeight = pdf.internal.pageSize.getHeight();
//       const imgWidth = canvas.width;
//       const imgHeight = canvas.height;
//       const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
//       const imgScaledWidth = imgWidth * ratio;
//       const imgScaledHeight = imgHeight * ratio;

//       // Handle multi-page PDF for long content
//       let heightLeft = imgHeight;
//       let position = 0;

//       while (heightLeft > 0) {
//         pdf.addImage(imgData, "PNG", 0, position, imgScaledWidth, imgScaledHeight);
//         heightLeft -= pdfHeight / ratio;
//         position -= pdfHeight;
//         if (heightLeft > 0) {
//           pdf.addPage();
//         }
//       }

//       pdf.save(`${selectedJobSeeker.firstName}_${selectedJobSeeker.lastName}_Details.pdf`);
//       toast.success("PDF downloaded successfully!");
//     } catch (error) {
//       console.error("Error generating PDF:", error);
//       toast.error("Failed to generate PDF. Please try again.");
//     } finally {
//       setIsDownloading(false);
//     }
//   };

//   // Fetch job offers
//   const fetchJobOffers = async () => {
//     try {
//       const url = `${process.env.REACT_APP_API_URL}offer/all`;
//       console.log("Fetching Job Offers URL:", url);
//       const startTime = Date.now();
//       const controller = new AbortController();
//       const timeoutId = setTimeout(() => controller.abort(), 60000);
//       const response = await fetch(url, {
//         headers: {
//           "Content-Type": "application/json",
//           "Accept": "application/json",
//           "Authorization": `Bearer ${localStorage.getItem("token")}`, // Added JWT token
//         },
//         signal: controller.signal,
//       });
//       clearTimeout(timeoutId);
//       const responseTime = Date.now() - startTime;
//       console.log(`Job Offers Response Time: ${responseTime}ms`);
//       console.log("Job Offers Response Status:", response.status);
//       const result = await response.json();
//       console.log("Job Offers Response Body:", result);
//       if (!response.ok) {
//         throw new Error(`HTTP ${response.status}: Failed to fetch job offers`);
//       }
      
//       const offersArray = Array.isArray(result) ? result : (result.data || []);
//       setJobOffers(offersArray);
//     } catch (err) {
//       console.error("Job Offers Fetch Error:", err);
//       setError(`Failed to fetch job offers: ${err.message}`);
//     }
//   };

//   // Handle search
//   const handleSearch = async () => {
//     const trimmedQuery = typeof searchQuery === 'string' ? searchQuery.trim() : '';
//     console.log("--- Search Attempt ---");
//     console.log("Raw Query:", searchQuery);
//     console.log("Trimmed Query:", trimmedQuery);
//     console.log("API URL:", process.env.REACT_APP_API_URL);
//     if (!trimmedQuery) {
//       setJobSeekers([]);
//       setError("Please enter a valid search query");
//       console.log("Search aborted: Empty query");
//       return;
//     }
//     setIsLoading(true);
//     setError(null);
//     try {
//       const encodedQuery = encodeURIComponent(trimmedQuery);
//       const url = `${process.env.REACT_APP_API_URL}jobseeker/searchbyemployer?name=${encodedQuery}`;
//       console.log("Constructed Search URL:", url);
//       const startTime = Date.now();
//       const controller = new AbortController();
//       const timeoutId = setTimeout(() => controller.abort(), 60000);
//       const response = await fetch(url, {
//         method: 'GET',
//         headers: {
//           "Content-Type": "application/json",
//           "Accept": "application/json",
//           "Authorization": `Bearer ${localStorage.getItem("token")}`, // Added JWT token
//         },
//         signal: controller.signal,
//       });
//       clearTimeout(timeoutId);
//       const responseTime = Date.now() - startTime;
//       console.log(`Search Response Time: ${responseTime}ms`);
//       console.log("Search Response Status:", response.status);
//       const result = await response.json();
//       console.log("Search Response Body:", result);
//       if (!response.ok) {
//         throw new Error(`HTTP ${response.status}: ${result.message || "Search failed"}`);
//       }
//       if (!result.data || result.data.length === 0) {
//         setError("No jobseekers found for the given name");
//         setJobSeekers([]);
//       } else {
//         setJobSeekers(result.data);
//         await fetchJobOffers();
//       }
//     } catch (err) {
//       console.error("Search Error:", err);
//       setError(`Failed to fetch jobseekers: ${err.message}`);
//       setJobSeekers([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleKeyPress = (e) => {
//     if (e.key === "Enter") {
//       handleSearch();
//     }
//   };

//   const handleFormChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleFormSubmit = async (e) => {
//     e.preventDefault();
//     setIsPaymentModalOpen(true);
//   };

//   const handlePayment = async () => {
//     try {
//       // Simulated Paystack payment
//       const paymentSuccess = true;
//       if (paymentSuccess) {
//         setPaymentStatus(true);
//         const url = `${process.env.REACT_APP_API_URL}admin/search-request`;
//         console.log("Submitting Search Request URL:", url);
//         const startTime = Date.now();
//         const controller = new AbortController();
//         const timeoutId = setTimeout(() => controller.abort(), 5000);
//         const response = await fetch(url, {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             "Accept": "application/json",
//             "Authorization": `Bearer ${localStorage.getItem("token")}`, // Added JWT token
//           },
//           body: JSON.stringify({
//             ...formData,
//             jobSeekerId: selectedJobSeeker._id,
//             paymentStatus: true,
//           }),
//           signal: controller.signal,
//         });
//         clearTimeout(timeoutId);
//         const responseTime = Date.now() - startTime;
//         console.log(`Search Request Response Time: ${responseTime}ms`);
//         console.log("Search Request Response Status:", response.status);
//         const result = await response.json();
//         console.log("Search Request Response Body:", result);
//         if (!response.ok) {
//           throw new Error(`HTTP ${response.status}: Failed to submit search request`);
//         }
//         setIsPaymentModalOpen(false);
//         setIsJobOfferModalOpen(false);
//         toast.success("Search request submitted successfully");
//       } else {
//         setPaymentStatus(false);
//         toast.error("Payment failed");
//       }
//     } catch (err) {
//       console.error("Payment Submission Error:", err);
//       setError(`Failed to process payment: ${err.message}`);
//     }
//   };

//   const getStatusColor = (status) => {
//     switch (status) {
//       case "Applied":
//       case "Shortlisted":
//         return "bg-yellow-100 text-yellow-800";
//       case "Interviewed":
//         return "bg-purple-100 text-purple-800";
//       case "Rejected":
//         return "bg-red-100 text-red-800";
//       case "Offer":
//       case "Accepted":
//         return "bg-green-100 text-green-800";
//       default:
//         return "bg-gray-100 text-gray-800";
//     }
//   };

//   const renderApplicationTable = (applications, title) => (
//     <div className="mb-8">
//       <h3 className="text-lg font-semibold mb-4">{title}</h3>
//       <div className="relative overflow-x-auto rounded-lg border border-gray-200">
//         <table className="w-full text-sm text-left">
//           <thead className="text-xs uppercase bg-gray-50">
//             <tr>
//               <th className="px-6 py-3 font-medium text-gray-500">Company</th>
//               <th className="px-6 py-3 font-medium text-gray-500">Position</th>
//               <th className="px-6 py-3 font-medium text-gray-500">Date Applied</th>
//               <th className="px-6 py-3 font-medium text-gray-500">Status</th>
//               <th className="px-6 py-3 font-medium text-gray-500">Reason</th>
//               <th className="px-6 py-3 font-medium text-gray-500">Cover Letter</th>
//               <th className="px-6 py-3 font-medium text-gray-500">Resume</th>
//               <th className="px-6 py-3 font-medium text-gray-500">Availability</th>
//               <th className="px-6 py-3 font-medium text-gray-500">Open for Students</th>
//               <th className="px-6 py-3 font-medium text-gray-500">Additional Doc</th>
//             </tr>
//           </thead>
//           <tbody className="divide-y divide-gray-200">
//             {applications?.length > 0 ? (
//               applications.map((app, index) => (
//                 <tr
//                   key={index}
//                   className="bg-white hover:bg-gray-50 transition-colors"
//                 >
//                   <td className="px-6 py-4">
//                     <div>
//                       <div className="font-semibold">
//                         {app.companyId?.companyName || "N/A"}
//                       </div>
//                       <div className="text-sm text-gray-500">
//                         {app.companyAddress || "N/A"}
//                       </div>
//                     </div>
//                   </td>
//                   <td className="px-6 py-4">{app.position || "N/A"}</td>
//                   <td className="px-6 py-4">
//                     {app.createdAt ? new Date(app.createdAt).toLocaleDateString() : "N/A"}
//                   </td>
//                   <td className="px-6 py-4">
//                     <span
//                       className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(
//                         app.status
//                       )}`}
//                     >
//                       {app.status || "N/A"}
//                     </span>
//                   </td>
//                   <td className="px-6 py-4">{app.reasonForRejection || "N/A"}</td>
//                   <td className="px-6 py-4">{app.coverLetter || "N/A"}</td>
//                   <td className="px-6 py-4">{app.resume || "N/A"}</td>
//                   <td className="px-6 py-4">{app.availability || "N/A"}</td>
//                   <td className="px-6 py-4">{app.openForStudents || "N/A"}</td>
//                   <td className="px-6 py-4">{app.additionalDocument || "N/A"}</td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="10" className="px-6 py-4 text-center text-gray-500">
//                   No applications found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//         {applications?.length > 0 && applications.some(app => app.additionalQuestionResponse?.length > 0) && (
//           <div className="px-6 py-4">
//             <h4 className="text-sm font-medium text-gray-700 mb-2">Additional Questions</h4>
//             <ul className="list-disc pl-5">
//               {applications
//                 .filter(app => app.additionalQuestionResponse?.length > 0)
//                 .map((app, appIndex) =>
//                   app.additionalQuestionResponse.map((resp, respIndex) => (
//                     <li key={`${appIndex}-${respIndex}`} className="font-medium">
//                       {typeof resp === 'object' && resp !== null ? (
//                         <>
//                           <span className="font-semibold">Question: </span>{resp.question || "N/A"}
//                           <br />
//                           <span className="font-semibold">Response: </span>{resp.response || "N/A"}
//                         </>
//                       ) : (
//                         resp
//                       )}
//                     </li>
//                   ))
//                 )}
//             </ul>
//           </div>
//         )}
//       </div>
//     </div>
//   );

//   const renderJobOfferDetails = () => {
//     const seekerOffers = Array.isArray(jobOffers) ? jobOffers.filter(offer => offer.candidate?._id === selectedJobSeeker._id) : [];
//     return (
//       <div className="mb-8">
//         <h3 className="text-lg font-semibold mb-4">Job Offers</h3>
//         <button
//           onClick={() => setIsJobOfferModalOpen(true)}
//           className="mb-4 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
//         >
//           View Current Job Offer Details
//         </button>
//         {seekerOffers.length > 0 ? (
//           <div className="relative overflow-x-auto rounded-lg border border-gray-200">
//             <table className="w-full text-sm text-left">
//               <thead className="text-xs uppercase bg-gray-50">
//                 <tr>
//                   <th className="px-6 py-3 font-medium text-gray-500">Employer</th>
//                   <th className="px-6 py-3 font-medium text-gray-500">Amount</th>
//                   <th className="px-6 py-3 font-medium text-gray-500">Resumption Date</th>
//                   <th className="px-6 py-3 font-medium text-gray-500">Resumption Time</th>
//                   <th className="px-6 py-3 font-medium text-gray-500">Status</th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-200">
//                 {seekerOffers.map((offer, index) => (
//                   <tr key={index} className="bg-white hover:bg-gray-50 transition-colors">
//                     <td className="px-6 py-4">{offer.employer?.companyName || "N/A"}</td>
//                     <td className="px-6 py-4">{offer.amount || "N/A"}</td>
//                     <td className="px-6 py-4">{offer.resumptionDate || "N/A"}</td>
//                     <td className="px-6 py-4">{offer.resumptionTime || "N/A"}</td>
//                     <td className="px-6 py-4">
//                       <span
//                         className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(
//                           offer.status
//                         )}`}
//                       >
//                         {offer.status || "N/A"}
//                       </span>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         ) : (
//           <p className="text-gray-500">No job offers found for this job seeker</p>
//         )}
//       </div>
//     );
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedJobSeeker(null);
//   };

//   return (
//     <div className="bg-white shadow-sm rounded-lg p-6">
//       <h2 className="text-lg font-semibold text-gray-900 mb-4">Search Jobseeker</h2>
//       <div className="flex gap-4 mb-4">
//         <input
//           type="text"
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//           onKeyPress={handleKeyPress}
//           placeholder="Enter jobseeker name"
//           className="flex-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//         />
//         <button
//           onClick={handleSearch}
//           disabled={isLoading}
//           className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-blue-300"
//         >
//           {isLoading ? "Searching..." : "Search"}
//         </button>
//       </div>
//       {error && <p className="text-red-500 mb-4">{error}</p>}
//       {isLoading && <p className="text-gray-500 mb-4">Loading...</p>}
//       {jobSeekers.length > 0 && (
//         <div className="mt-4">
//           <h3 className="text-md font-medium text-gray-700 mb-2">Search Results</h3>
//           <ul className="divide-y divide-gray-200">
//             {jobSeekers.map((jobSeeker) => (
//               <li
//                 key={jobSeeker._id}
//                 className="py-2 flex justify-between items-center"
//               >
//                 <span>{`${jobSeeker.firstName} ${jobSeeker.lastName}`}</span>
//                 <button
//                   onClick={() => {
//                     setSelectedJobSeeker(jobSeeker);
//                     setIsModalOpen(true);
//                   }}
//                   className="p-2 hover:bg-gray-100 rounded-full"
//                 >
//                   <MdBorderHorizontal className="w-4 h-4" />
//                 </button>
//               </li>
//             ))}
//           </ul>
//         </div>
//       )}
//       {isModalOpen && selectedJobSeeker && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div
//             id="job-seeker-modal"
//             className="bg-white rounded-lg p-6 max-w-4xl w-full max-h-[80vh] overflow-y-auto"
//           >
//             <div className="flex justify-between items-center mb-4">
//               <h2 className="text-xl font-semibold">
//                 {`${selectedJobSeeker.firstName} ${selectedJobSeeker.lastName}'s Details`}
//               </h2>
//               <div className="flex items-center space-x-2">
//                 <button
//                   onClick={handleDownloadPDF}
//                   disabled={isDownloading}
//                   className={`bg-[#F97316] text-white px-4 py-2 rounded hover:bg-[#EA580C] transition-colors ${
//                     isDownloading ? "opacity-50 cursor-not-allowed" : ""
//                   }`}
//                   aria-label="Download job seeker details as PDF"
//                 >
//                   {isDownloading ? "Downloading..." : "Download PDF"}
//                 </button>
//                 <button
//                   onClick={handleCloseModal}
//                   className="text-gray-500 hover:text-gray-700"
//                   aria-label="Close modal"
//                 >
//                   ✕
//                 </button>
//               </div>
//             </div>
//             <div className="space-y-6">
//               <div>
//                 <h3 className="text-lg font-semibold mb-2">Personal Information</h3>
//                 <p><strong>Email:</strong> {selectedJobSeeker.email || "N/A"}</p>
//                 <p><strong>Address:</strong> {selectedJobSeeker.address || "N/A"}</p>
//                 <p><strong>Address 2:</strong> {selectedJobSeeker.address2 || "N/A"}</p>
//                 <p><strong>Date of Birth:</strong> {selectedJobSeeker.dateOfBirth || "N/A"}</p>
//                 <p><strong>Race:</strong> {selectedJobSeeker.race || "N/A"}</p>
//                 <p><strong>Disability:</strong> {selectedJobSeeker.disability || "N/A"}</p>
//                 <p><strong>State:</strong> {selectedJobSeeker.state || "N/A"}</p>
//                 <p><strong>Local Government:</strong> {selectedJobSeeker.localGovernment || "N/A"}</p>
//                 <p><strong>Country:</strong> {selectedJobSeeker.country || "N/A"}</p>
//                 <p><strong>Gender:</strong> {selectedJobSeeker.gender || "N/A"}</p>
//                 <p><strong>Phone Number:</strong> {selectedJobSeeker.phoneNumber || "N/A"}</p>
//                 <p><strong>WhatsApp Number:</strong> {selectedJobSeeker.whatsappNumber || "N/A"}</p>
//                 {selectedJobSeeker.jobDecision === "job-changer" && (
//                   <p><strong>Job Decision Salary:</strong> {selectedJobSeeker.jobDecisionSalary || "N/A"}</p>
//                 )}
//                 <p><strong>Interested Jobs:</strong> {selectedJobSeeker.interestedJob?.join(", ") || "N/A"}</p>
//                 <p><strong>Job Choices:</strong> {selectedJobSeeker.jobChoice?.join(", ") || "N/A"}</p>
//                 <p><strong>Account Balance:</strong> {selectedJobSeeker.accountBalance || "0"}</p>
//                 <p><strong>Is Verified:</strong> {selectedJobSeeker.isVerified ? "Yes" : "No"}</p>
//                 <p><strong>Is Blacklisted:</strong> {selectedJobSeeker.isBlacklisted ? "Yes" : "No"}</p>
//                 <p><strong>Last Login:</strong> {selectedJobSeeker.lastLogin ? new Date(selectedJobSeeker.lastLogin).toLocaleString() : "N/A"}</p>
//               </div>
//               {renderApplicationTable(
//                 selectedJobSeeker.appliedJobs?.filter(
//                   (app) =>
//                     app.status?.toLowerCase() === "applied" ||
//                     app.status?.toLowerCase() === "shortlisted"
//                 ) || [],
//                 "Applied Jobs"
//               )}
//               {renderApplicationTable(
//                 selectedJobSeeker.appliedJobs?.filter(
//                   (app) => app.status?.toLowerCase() === "interviewed"
//                 ) || [],
//                 "Scheduled Jobs (Interviews)"
//               )}
//               {renderApplicationTable(
//                 selectedJobSeeker.appliedJobs?.filter(
//                   (app) => app.status?.toLowerCase() === "rejected"
//                 ) || [],
//                 "Rejected Jobs"
//               )}
//               {renderApplicationTable(
//                 selectedJobSeeker.appliedJobs?.filter(
//                   (app) =>
//                     app.status?.toLowerCase() === "offer" ||
//                     app.status?.toLowerCase() === "accepted"
//                 ) || [],
//                 "Hired Jobs"
//               )}
//               {renderJobOfferDetails()}
//             </div>
//           </div>
//         </div>
//       )}
//       {isJobOfferModalOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg p-6 max-w-md w-full">
//             <h2 className="text-xl font-semibold mb-4">Advanced Search Form</h2>
//             <form onSubmit={handleFormSubmit}>
//               <div className="mb-4">
//                 <label className="block text-sm font-medium text-gray-700">Your Name</label>
//                 <input
//                   type="text"
//                   name="searcherName"
//                   value={formData.searcherName}
//                   onChange={handleFormChange}
//                   required
//                   className="w-full p-2 border border-gray-300 rounded-md"
//                 />
//               </div>
//               <div className="mb-4">
//                 <label className="block text-sm font-medium text-gray-700">
//                   Job Seeker's Unique ID
//                 </label>
//                 <input
//                   type="text"
//                   name="jobSeekerUniqueId"
//                   value={formData.jobSeekerUniqueId}
//                   onChange={handleFormChange}
//                   required
//                   className="w-full p-2 border border-gray-300 rounded-md"
//                 />
//               </div>
//               <div className="mb-4">
//                 <label className="block text-sm font-medium text-gray-700">
//                   Why do you want to make this advanced search?
//                 </label>
//                 <textarea
//                   name="searchReason"
//                   value={formData.searchReason}
//                   onChange={handleFormChange}
//                   required
//                   className="w-full p-2 border border-gray-300 rounded-md"
//                 />
//               </div>
//               <div className="mb-4">
//                 <label className="block text-sm font-medium text-gray-700">
//                   Email to send information to
//                 </label>
//                 <input
//                   type="email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleFormChange}
//                   required
//                   className="w-full p-2 border border-gray-300 rounded-md"
//                 />
//               </div>
//               <button
//                 type="submit"
//                 className="w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
//               >
//                 Submit
//               </button>
//             </form>
//             <button
//               onClick={() => setIsJobOfferModalOpen(false)}
//               className="mt-4 text-gray-500 hover:text-gray-700"
//             >
//               Cancel
//             </button>
//           </div>
//         </div>
//       )}
//       {isPaymentModalOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg p-6 max-w-md w-full">
//             <h2 className="text-xl font-semibold mb-4">Paystack Payment</h2>
//             <p className="mb-4">Please complete the payment of ₦5000 to access job offer details.</p>
//             <button
//               onClick={handlePayment}
//               className="w-full px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
//             >
//               Pay ₦5000
//             </button>
//             <button
//               onClick={() => setIsPaymentModalOpen(false)}
//               className="mt-4 text-gray-500 hover:text-gray-700"
//             >
//               Cancel
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// JobSeekerSearch.propTypes = {
//   // Add propTypes if the component accepts props
// };

// export default JobSeekerSearch;











import React, { useState, useEffect } from "react";
import { MdBorderHorizontal } from "react-icons/md";
import PropTypes from "prop-types";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { toast } from "sonner";
import io from "socket.io-client";

const socket = io(process.env.REACT_APP_API_URL, {
  auth: { token: localStorage.getItem("token") },
});

const JobSeekerSearch = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [jobSeekers, setJobSeekers] = useState([]);
  const [selectedJobSeeker, setSelectedJobSeeker] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const [jobOffers, setJobOffers] = useState([]);
  const [isJobOfferModalOpen, setIsJobOfferModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    searcherName: "",
    jobSeekerUniqueId: "",
    searchReason: "",
    email: "",
  });
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [searchHistory, setSearchHistory] = useState([]);
  const [notifications, setNotifications] = useState([]);


    // Fetch Search History
  const fetchSearchHistory = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}search/search-history`, {
        headers: {
          "Authorization": `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const result = await response.json();
      if (response.ok) {
        setSearchHistory(result.data);
      } else {
        throw new Error(result.message || "Failed to fetch search history");
      }
    } catch (err) {
      console.error("Fetch Search History Error:", err);
      setError(`Failed to fetch search history: ${err.message}`);
    }
  };

  // Fetch search history on component mount
  useEffect(() => {
    fetchSearchHistory();
  }, []);

  const searcherId = localStorage.getItem("userId");


    // Save Search History
  const saveSearchHistory = async (jobSeekerId, query, searcherId) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}search/search-history`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ jobSeekerId, searchQuery: query, searcherId }),
      });
      const result = await response.json();
      if (!response.ok) {
        throw new Error(result.message || "Failed to save search history");
      }
      await fetchSearchHistory(); // Refresh search history
    } catch (err) {
      console.error("Save Search History Error:", err);
      setError(`Failed to save search history: ${err.message}`);
    }
  };




  //download button 
  const handleDownloadPDF = async () => {
    setIsDownloading(true);
    try {
      const modalContent = document.querySelector("#job-seeker-modal");
      if (!modalContent) {
        toast.error("Error: Modal content not found.");
        return;
      }

      // Ensure all content is visible by temporarily removing max-height and overflow
      const originalStyle = modalContent.style.cssText;
      modalContent.style.maxHeight = "none";
      modalContent.style.overflow = "visible";

      const canvas = await html2canvas(modalContent, {
        scale: 2, // Higher resolution for clarity
        useCORS: true, // Handle cross-origin resources
        backgroundColor: "#ffffff", // Match modal background
        windowWidth: modalContent.scrollWidth, // Capture full width
        windowHeight: modalContent.scrollHeight, // Capture full height
      });

      // Restore original styles
      modalContent.style.cssText = originalStyle;

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "px",
        format: "a4",
      });

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
      const imgScaledWidth = imgWidth * ratio;
      const imgScaledHeight = imgHeight * ratio;

      // Handle multi-page PDF if content is too long
      let heightLeft = imgHeight;
      let position = 0;

      while (heightLeft > 0) {
        pdf.addImage(imgData, "PNG", 0, position, imgScaledWidth, imgScaledHeight);
        heightLeft -= pdfHeight / ratio;
        position -= pdfHeight;
        if (heightLeft > 0) {
          pdf.addPage();
        }
      }

      pdf.save(`${selectedJobSeeker.firstName}_${selectedJobSeeker.lastName}_Details.pdf`);
      toast.success("PDF downloaded successfully!");
    } catch (error) {
      console.error("Error generating PDF:", error);
      toast.error("Failed to generate PDF. Please try again.");
    } finally {
      setIsDownloading(false);
    }
  };

  // Fetch job offers
  const fetchJobOffers = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}offer/all`;
      console.log("Fetching Job Offers URL:", url);
      const startTime = Date.now();
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 60000); 
      const response = await fetch(url, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        signal: controller.signal,
      });
      clearTimeout(timeoutId);
      const responseTime = Date.now() - startTime;
      console.log(`Job Offers Response Time: ${responseTime}ms`);
      console.log("Job Offers Response Status:", response.status);
      const result = await response.json();
      console.log("Job Offers Response Body:", result);
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: Failed to fetch job offers`);
      }
      
      const offersArray = Array.isArray(result) ? result : (result.data || []);
      setJobOffers(offersArray);
    } catch (err) {
      console.error("Job Offers Fetch Error:", err);
      setError(`Failed to fetch job offers: ${err.message}`);
    }
  };

  // Handle search
  // const handleSearch = async () => {
  //   const trimmedQuery = typeof searchQuery === 'string' ? searchQuery.trim() : '';
  //   console.log("--- Search Attempt ---");
  //   console.log("Raw Query:", searchQuery);
  //   console.log("Trimmed Query:", trimmedQuery);
  //   console.log("API URL:", process.env.REACT_APP_API_URL);
  //   if (!trimmedQuery) {
  //     setJobSeekers([]);
  //     setError("Please enter a valid search query");
  //     console.log("Search aborted: Empty query");
  //     return;
  //   }
  //   setIsLoading(true);
  //   setError(null);
  //   try {
  //     const encodedQuery = encodeURIComponent(trimmedQuery);
  //     const url = `${process.env.REACT_APP_API_URL}jobseeker/searchbyemployer?name=${encodedQuery}`;
  //     console.log("Constructed Search URL:", url);
  //     const startTime = Date.now();
  //     const controller = new AbortController();
  //     const timeoutId = setTimeout(() => controller.abort(), 600000); 
  //     const response = await fetch(url, {
  //       method: 'GET',
  //       headers: {
  //         "Content-Type": "application/json",
  //         "Accept": "application/json",
  //       },
  //       signal: controller.signal,
  //     });
  //     clearTimeout(timeoutId);
  //     const responseTime = Date.now() - startTime;
  //     console.log(`Search Response Time: ${responseTime}ms`);
  //     console.log("Search Response Status:", response.status);
  //     const result = await response.json();
  //     console.log("Search Response Body:", result);
  //     if (!response.ok) {
  //       throw new Error(`HTTP ${response.status}: ${result.message || "Search failed"}`);
  //     }
  //     if (!result.data || result.data.length === 0) {
  //       setError("No jobseekers found for the given name");
  //       setJobSeekers([]);
  //     } else {
  //       setJobSeekers(result.data);
  //       await fetchJobOffers();
  //     }
  //   } catch (err) {
  //     console.error("Search Error:", err);
  //     setError(`Failed to fetch jobseekers: ${err.message}`);
  //     setJobSeekers([]);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleSearch = async () => {
    const trimmedQuery = typeof searchQuery === "string" ? searchQuery.trim() : "";
    if (!trimmedQuery) {
      setJobSeekers([]);
      setError("Please enter a valid search query");
      return;
    }
    setIsLoading(true);
    setError(null);
    try {
      const encodedQuery = encodeURIComponent(trimmedQuery);
      const url = `${process.env.REACT_APP_API_URL}jobseeker/searchbyemployer?name=${encodedQuery}`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const result = await response.json();
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${result.message || "Search failed"}`);
      }
      if (!result.data || result.data.length === 0) {
        setError("No jobseekers found for the given name");
        setJobSeekers([]);
      } else {
        setJobSeekers(result.data);
        // Save search history for each job seeker found
        result.data.forEach((jobSeeker) => {
          saveSearchHistory(jobSeeker._id, trimmedQuery);
        });
        await fetchJobOffers();
      }
    } catch (err) {
      console.error("Search Error:", err);
      setError(`Failed to fetch jobseekers: ${err.message}`);
      setJobSeekers([]);
    } finally {
      setIsLoading(false);
    }
  };



  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const handleFormChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setIsPaymentModalOpen(true);
  };

  const handlePayment = async () => {
    try {
      // Simulated Paystack payment
      const paymentSuccess = true;
      if (paymentSuccess) {
        setPaymentStatus(true);
        const url = `${process.env.REACT_APP_API_URL}admin/search-request`;
        console.log("Submitting Search Request URL:", url);
        const startTime = Date.now();
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 5000); // 5s timeout
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
          },
          body: JSON.stringify({
            ...formData,
            jobSeekerId: selectedJobSeeker._id,
            paymentStatus: true,
          }),
          signal: controller.signal,
        });
        clearTimeout(timeoutId);
        const responseTime = Date.now() - startTime;
        console.log(`Search Request Response Time: ${responseTime}ms`);
        console.log("Search Request Response Status:", response.status);
        const result = await response.json();
        console.log("Search Request Response Body:", result);
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: Failed to submit search request`);
        }
        setIsPaymentModalOpen(false);
        setIsJobOfferModalOpen(false);
        alert("Search request submitted successfully");
      } else {
        setPaymentStatus(false);
        alert("Payment failed");
      }
    } catch (err) {
      console.error("Payment Submission Error:", err);
      setError(`Failed to process payment: ${err.message}`);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Applied":
      case "Shortlisted":
        return "bg-yellow-100 text-yellow-800";
      case "Interviewed":
        return "bg-purple-100 text-purple-800";
      case "Rejected":
        return "bg-red-100 text-red-800";
      case "Offer":
      case "Accepted":
        return "bg-green-100 text-green-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  const renderApplicationTable = (applications, title) => (
    <div className="mb-8">
      <h3 className="text-lg font-semibold mb-4">{title}</h3>
      <div className="relative overflow-x-auto rounded-lg border border-gray-200">
        <table className="w-full text-sm text-left">
          <thead className="text-xs uppercase bg-gray-50">
            <tr>
              <th className="px-6 py-3 font-medium text-gray-500">Company</th>
              <th className="px-6 py-3 font-medium text-gray-500">Position</th>
              <th className="px-6 py-3 font-medium text-gray-500">Date Applied</th>
              <th className="px-6 py-3 font-medium text-gray-500">Status</th>
              <th className="px-6 py-3 font-medium text-gray-500">Reason</th>
              <th className="px-6 py-3 font-medium text-gray-500">Cover Letter</th>
              <th className="px-6 py-3 font-medium text-gray-500">Resume</th>
              <th className="px-6 py-3 font-medium text-gray-500">Availability</th>
              <th className="px-6 py-3 font-medium text-gray-500">Open for Students</th>
              <th className="px-6 py-3 font-medium text-gray-500">Additional Doc</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {applications?.length > 0 ? (
              applications.map((app, index) => (
                <tr
                  key={index}
                  className="bg-white hover:bg-gray-50 transition-colors"
                >
                  <td className="px-6 py-4">
                    <div>
                      <div className="font-semibold">
                        {app.companyId?.companyName || "N/A"}
                      </div>
                      <div className="text-sm text-gray-500">
                        {app.companyAddress || "N/A"}
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4">{app.position || "N/A"}</td>
                  <td className="px-6 py-4">
                    {app.createdAt ? new Date(app.createdAt).toLocaleDateString() : "N/A"}
                  </td>
                  <td className="px-6 py-4">
                    <span
                      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(
                        app.status
                      )}`}
                    >
                      {app.status || "N/A"}
                    </span>
                  </td>
                  <td className="px-6 py-4">{app.reasonForRejection || "N/A"}</td>
                  <td className="px-6 py-4">{app.coverLetter || "N/A"}</td>
                  <td className="px-6 py-4">{app.resume || "N/A"}</td>
                  <td className="px-6 py-4">{app.availability || "N/A"}</td>
                  <td className="px-6 py-4">{app.openForStudents || "N/A"}</td>
                  <td className="px-6 py-4">{app.additionalDocument || "N/A"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="10" className="px-6 py-4 text-center text-gray-500">
                  No applications found
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {applications?.length > 0 && applications.some(app => app.additionalQuestionResponse?.length > 0) && (
          <div className="px-6 py-4">
            <h4 className="text-sm font-medium text-gray-700 mb-2">Additional Questions</h4>
            <ul className="list-disc pl-5">
              {applications
                .filter(app => app.additionalQuestionResponse?.length > 0)
                .map((app, appIndex) =>
                  app.additionalQuestionResponse.map((resp, respIndex) => (
                    <li key={`${appIndex}-${respIndex}`} className="font-medium">
                      {typeof resp === 'object' && resp !== null ? (
                        <>
                          <span className="font-semibold">Question: </span>{resp.question || "N/A"}
                          <br />
                          <span className="font-semibold">Response: </span>{resp.response || "N/A"}
                        </>
                      ) : (
                        resp
                      )}
                    </li>
                  ))
                )}
            </ul>
          </div>
        )}
      </div>
    </div>
  );

  const renderJobOfferDetails = () => {
    const seekerOffers = Array.isArray(jobOffers) ? jobOffers.filter(offer => offer.candidate?._id === selectedJobSeeker._id) : [];
    return (
      <div className="mb-8">
        <h3 className="text-lg font-semibold mb-4">Job Offers</h3>
        <button
          onClick={() => setIsJobOfferModalOpen(true)}
          className="mb-4 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          View Current Job Offer Details
        </button>
        {seekerOffers.length > 0 ? (
          <div className="relative overflow-x-auto rounded-lg border border-gray-200">
            <table className="w-full text-sm text-left">
              <thead className="text-xs uppercase bg-gray-50">
                <tr>
                  <th className="px-6 py-3 font-medium text-gray-500">Employer</th>
                  <th className="px-6 py-3 font-medium text-gray-500">Amount</th>
                  <th className="px-6 py-3 font-medium text-gray-500">Resumption Date</th>
                  <th className="px-6 py-3 font-medium text-gray-500">Resumption Time</th>
                  <th className="px-6 py-3 font-medium text-gray-500">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {seekerOffers.map((offer, index) => (
                  <tr key={index} className="bg-white hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4">{offer.employer?.companyName || "N/A"}</td>
                    <td className="px-6 py-4">{offer.amount || "N/A"}</td>
                    <td className="px-6 py-4">{offer.resumptionDate || "N/A"}</td>
                    <td className="px-6 py-4">{offer.resumptionTime || "N/A"}</td>
                    <td className="px-6 py-4">
                      <span
                        className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(
                          offer.status
                        )}`}
                      >
                        {offer.status || "N/A"}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-gray-500">No job offers found for this job seeker</p>
        )}
      </div>
    );
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedJobSeeker(null);
  };

  return (
    <div className="bg-white shadow-sm rounded-lg p-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Search jobseeker</h2>
      <div className="flex gap-4 mb-4">
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Enter jobseeker name"
          className="flex-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <button
          onClick={handleSearch}
          disabled={isLoading}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-blue-300"
        >
          {isLoading ? "Searching..." : "Search"}
        </button>
      </div>
      {error && <p className="text-red-500 mb-4">{error}</p>}
      {isLoading && <p className="text-gray-500 mb-4">Loading...</p>}
      {jobSeekers.length > 0 && (
        <div className="mt-4">
          <h3 className="text-md font-medium text-gray-700 mb-2">Search Results</h3>
          <ul className="divide-y divide-gray-200">
            {jobSeekers.map((jobSeeker) => (
              <li
                key={jobSeeker._id}
                className="py-2 flex justify-between items-center"
              >
                <span>{`${jobSeeker.firstName} ${jobSeeker.lastName}`}</span>
                <button
                  onClick={() => {
                    setSelectedJobSeeker(jobSeeker);
                    setIsModalOpen(true);
                  }}
                  className="p-2 hover:bg-gray-100 rounded-full"
                >
                  <MdBorderHorizontal className="w-4 h-4" />
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
      {isModalOpen && selectedJobSeeker && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-4xl w-full max-h-[80vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold">
                {`${selectedJobSeeker.firstName} ${selectedJobSeeker.lastName}'s Details`}
              </h2>
              {/* <button
                onClick={handleCloseModal}
                className="text-gray-500 hover:text-gray-700"
              >
                ✕
              </button> */}
              <div className="flex items-center space-x-2">
                <button
                  onClick={handleDownloadPDF}
                  disabled={isDownloading}
                  className={`bg-[#F97316] text-white px-4 py-2 rounded hover:bg-[#EA580C] transition-colors ${
                    isDownloading ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                  aria-label="Download job seeker details as PDF"
                >
                  {isDownloading ? "Downloading..." : "Download PDF"}
                </button>
                <button
                  onClick={handleCloseModal}
                  className="text-gray-500 hover:text-gray-700"
                  aria-label="Close modal"
                >
                  ✕
                </button>
              </div>
            </div>
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-semibold mb-2">Personal Information</h3>
                <p><strong>Email:</strong> {selectedJobSeeker.email || "N/A"}</p>
                <p><strong>Address:</strong> {selectedJobSeeker.address || "N/A"}</p>
                <p><strong>Address 2:</strong> {selectedJobSeeker.address2 || "N/A"}</p>
                <p><strong>Date of Birth:</strong> {selectedJobSeeker.dateOfBirth || "N/A"}</p>
                <p><strong>Race:</strong> {selectedJobSeeker.race || "N/A"}</p>
                <p><strong>Disability:</strong> {selectedJobSeeker.disability || "N/A"}</p>
                <p><strong>State:</strong> {selectedJobSeeker.state || "N/A"}</p>
                <p><strong>Local Government:</strong> {selectedJobSeeker.localGovernment || "N/A"}</p>
                <p><strong>Country:</strong> {selectedJobSeeker.country || "N/A"}</p>
                <p><strong>Gender:</strong> {selectedJobSeeker.gender || "N/A"}</p>
                <p><strong>Phone Number:</strong> {selectedJobSeeker.phoneNumber || "N/A"}</p>
                <p><strong>WhatsApp Number:</strong> {selectedJobSeeker.whatsappNumber || "N/A"}</p>
                {
                  selectedJobSeeker.jobDecision === "job-changer" && (
                    <p><strong>Job Decision Salary:</strong> {selectedJobSeeker.jobDecisionSalary || "N/A"}</p>
                  )
                }
             
                <p><strong>Interested Jobs:</strong> {selectedJobSeeker.interestedJob?.join(", ") || "N/A"}</p>
                <p><strong>Job Choices:</strong> {selectedJobSeeker.jobChoice?.join(", ") || "N/A"}</p>
                <p><strong>Account Balance:</strong> {selectedJobSeeker.accountBalance || "0"}</p>
                <p><strong>Is Verified:</strong> {selectedJobSeeker.isVerified ? "Yes" : "No"}</p>
                <p><strong>Is Blacklisted:</strong> {selectedJobSeeker.isBlacklisted ? "Yes" : "No"}</p>
                <p><strong>Last Login:</strong> {selectedJobSeeker.lastLogin ? new Date(selectedJobSeeker.lastLogin).toLocaleString() : "N/A"}</p>
              </div>
              {renderApplicationTable(
                selectedJobSeeker.appliedJobs?.filter(
                  (app) =>
                    app.status?.toLowerCase() === "applied" ||
                    app.status?.toLowerCase() === "shortlisted"
                ) || [],
                "Applied Jobs"
              )}
              {renderApplicationTable(
                selectedJobSeeker.appliedJobs?.filter(
                  (app) => app.status?.toLowerCase() === "interviewed"
                ) || [],
                "Scheduled Jobs (Interviews)"
              )}
              {renderApplicationTable(
                selectedJobSeeker.appliedJobs?.filter(
                  (app) => app.status?.toLowerCase() === "rejected"
                ) || [],
                "Rejected Jobs"
              )}
              {renderApplicationTable(
                selectedJobSeeker.appliedJobs?.filter(
                  (app) =>
                    app.status?.toLowerCase() === "offer" ||
                    app.status?.toLowerCase() === "accepted"
                ) || [],
                "Hired Jobs"
              )}
              {renderJobOfferDetails()}
            </div>
          </div>
        </div>
      )}
      {isJobOfferModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full">
            <h2 className="text-xl font-semibold mb-4">Advanced Search Form</h2>
            <form onSubmit={handleFormSubmit}>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">Your Name</label>
                <input
                  type="text"
                  name="searcherName"
                  value={formData.searcherName}
                  onChange={handleFormChange}
                  required
                  className="w-full p-2 border border-gray-300 rounded-md"
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  Job Seeker's Unique ID
                </label>
                <input
                  type="text"
                  name="jobSeekerUniqueId"
                  value={formData.jobSeekerUniqueId}
                  onChange={handleFormChange}
                  required
                  className="w-full p-2 border border-gray-300 rounded-md"
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  Why do you want to make this advanced search?
                </label>
                <textarea
                  name="searchReason"
                  value={formData.searchReason}
                  onChange={handleFormChange}
                  required
                  className="w-full p-2 border border-gray-300 rounded-md"
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  Email to send information to
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleFormChange}
                  required
                  className="w-full p-2 border border-gray-300 rounded-md"
                />
              </div>
              <button
                type="submit"
                className="w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
              >
                Submit
              </button>
            </form>
            <button
              onClick={() => setIsJobOfferModalOpen(false)}
              className="mt-4 text-gray-500 hover:text-gray-700"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
      {isPaymentModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full">
            <h2 className="text-xl font-semibold mb-4">Paystack Payment</h2>
            <p className="mb-4">Please complete the payment of ₦5000 to access job offer details.</p>
            <button
              onClick={handlePayment}
              className="w-full px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
            >
              Pay ₦5000
            </button>
            <button
              onClick={() => setIsPaymentModalOpen(false)}
              className="mt-4 text-gray-500 hover:text-gray-700"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default JobSeekerSearch;




























































// import React, { useState, useEffect } from "react";
// import { MdBorderHorizontal } from "react-icons/md";
// import PropTypes from "prop-types";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
// import { toast } from "sonner";
// import io from "socket.io-client";

// const socket = io(process.env.REACT_APP_API_URL, {
//   auth: { token: localStorage.getItem("token") },
// });

// const JobSeekerSearch = () => {
//   const [searchQuery, setSearchQuery] = useState("");
//   const [jobSeekers, setJobSeekers] = useState([]);
//   const [selectedJobSeeker, setSelectedJobSeeker] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [isDownloading, setIsDownloading] = useState(false);
//   const [jobOffers, setJobOffers] = useState([]);
//   const [isJobOfferModalOpen, setIsJobOfferModalOpen] = useState(false);
//   const [formData, setFormData] = useState({
//     searcherName: "",
//     jobSeekerUniqueId: "",
//     searchReason: "",
//     email: "",
//   });
//   const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
//   const [paymentStatus, setPaymentStatus] = useState(null);
//   const [searchHistory, setSearchHistory] = useState([]);
//   const [notifications, setNotifications] = useState([]);

//   // Initialize Socket.IO
//   useEffect(() => {
//     const userId = localStorage.getItem("userId"); // Assumes userId stored after login
//     socket.emit("join", userId);

//     socket.on("searchNotification", (notification) => {
//       setNotifications((prev) => [...prev, notification]);
//       toast.info(notification.message);
//     });

//     return () => {
//       socket.off("searchNotification");
//     };
//   }, []);

//   // Fetch Search History
//   const fetchSearchHistory = async () => {
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_URL}search-history`, {
//         headers: {
//           "Authorization": `Bearer ${localStorage.getItem("token")}`,
//         },
//       });
//       const result = await response.json();
//       if (response.ok) {
//         setSearchHistory(result.data);
//       } else {
//         throw new Error(result.message || "Failed to fetch search history");
//       }
//     } catch (err) {
//       console.error("Fetch Search History Error:", err);
//       setError(`Failed to fetch search history: ${err.message}`);
//     }
//   };

//   // Fetch search history on component mount
//   useEffect(() => {
//     fetchSearchHistory();
//   }, []);

//   // Save Search History
//   const saveSearchHistory = async (jobSeekerId, query) => {
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_URL}search-history`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "Authorization": `Bearer ${localStorage.getItem("token")}`,
//         },
//         body: JSON.stringify({ jobSeekerId, searchQuery: query }),
//       });
//       const result = await response.json();
//       if (!response.ok) {
//         throw new Error(result.message || "Failed to save search history");
//       }
//       await fetchSearchHistory(); // Refresh search history
//     } catch (err) {
//       console.error("Save Search History Error:", err);
//       setError(`Failed to save search history: ${err.message}`);
//     }
//   };

//   // Download PDF (from previous response)
//   const handleDownloadPDF = async () => {
//     setIsDownloading(true);
//     try {
//       const modalContent = document.querySelector("#job-seeker-modal");
//       if (!modalContent) {
//         toast.error("Error: Modal content not found.");
//         return;
//       }
//       const originalStyle = modalContent.style.cssText;
//       modalContent.style.maxHeight = "none";
//       modalContent.style.overflow = "visible";
//       const canvas = await html2canvas(modalContent, {
//         scale: 2,
//         useCORS: true,
//         backgroundColor: "#ffffff",
//         windowWidth: modalContent.scrollWidth,
//         windowHeight: modalContent.scrollHeight,
//       });
//       modalContent.style.cssText = originalStyle;
//       const imgData = canvas.toDataURL("image/png");
//       const pdf = new jsPDF({
//         orientation: "portrait",
//         unit: "px",
//         format: "a4",
//       });
//       const pdfWidth = pdf.internal.pageSize.getWidth();
//       const pdfHeight = pdf.internal.pageSize.getHeight();
//       const imgWidth = canvas.width;
//       const imgHeight = canvas.height;
//       const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
//       const imgScaledWidth = imgWidth * ratio;
//       const imgScaledHeight = imgHeight * ratio;
//       let heightLeft = imgHeight;
//       let position = 0;
//       while (heightLeft > 0) {
//         pdf.addImage(imgData, "PNG", 0, position, imgScaledWidth, imgScaledHeight);
//         heightLeft -= pdfHeight / ratio;
//         position -= pdfHeight;
//         if (heightLeft > 0) {
//           pdf.addPage();
//         }
//       }
//       pdf.save(`${selectedJobSeeker.firstName}_${selectedJobSeeker.lastName}_Details.pdf`);
//       toast.success("PDF downloaded successfully!");
//     } catch (error) {
//       console.error("Error generating PDF:", error);
//       toast.error("Failed to generate PDF. Please try again.");
//     } finally {
//       setIsDownloading(false);
//     }
//   };

//   // Fetch Job Offers (from previous response)
//   const fetchJobOffers = async () => {
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_URL}offer/all`, {
//         headers: {
//           "Authorization": `Bearer ${localStorage.getItem("token")}`,
//         },
//       });
//       const result = await response.json();
//       if (!response.ok) {
//         throw new Error(`HTTP ${response.status}: Failed to fetch job offers`);
//       }
//       const offersArray = Array.isArray(result) ? result : (result.data || []);
//       setJobOffers(offersArray);
//     } catch (err) {
//       console.error("Job Offers Fetch Error:", err);
//       setError(`Failed to fetch job offers: ${err.message}`);
//     }
//   };

//   // Handle Search (modified to save history)
//   const handleSearch = async () => {
//     const trimmedQuery = typeof searchQuery === "string" ? searchQuery.trim() : "";
//     if (!trimmedQuery) {
//       setJobSeekers([]);
//       setError("Please enter a valid search query");
//       return;
//     }
//     setIsLoading(true);
//     setError(null);
//     try {
//       const encodedQuery = encodeURIComponent(trimmedQuery);
//       const url = `${process.env.REACT_APP_API_URL}jobseeker/searchbyemployer?name=${encodedQuery}`;
//       const response = await fetch(url, {
//         method: "GET",
//         headers: {
//           "Authorization": `Bearer ${localStorage.getItem("token")}`,
//         },
//       });
//       const result = await response.json();
//       if (!response.ok) {
//         throw new Error(`HTTP ${response.status}: ${result.message || "Search failed"}`);
//       }
//       if (!result.data || result.data.length === 0) {
//         setError("No jobseekers found for the given name");
//         setJobSeekers([]);
//       } else {
//         setJobSeekers(result.data);
//         // Save search history for each job seeker found
//         result.data.forEach((jobSeeker) => {
//           saveSearchHistory(jobSeeker._id, trimmedQuery);
//         });
//         await fetchJobOffers();
//       }
//     } catch (err) {
//       console.error("Search Error:", err);
//       setError(`Failed to fetch jobseekers: ${err.message}`);
//       setJobSeekers([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleKeyPress = (e) => {
//     if (e.key === "Enter") {
//       handleSearch();
//     }
//   };

//   const handleFormChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleFormSubmit = async (e) => {
//     e.preventDefault();
//     setIsPaymentModalOpen(true);
//   };

//   const handlePayment = async () => {
//     try {
//       const paymentSuccess = true; // Simulated Paystack payment
//       if (paymentSuccess) {
//         setPaymentStatus(true);
//         const response = await fetch(`${process.env.REACT_APP_API_URL}admin/search-request`, {
//           method: "POST",
//           headers: {
//             "Authorization": `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             ...formData,
//             jobSeekerId: selectedJobSeeker._id,
//             paymentStatus: true,
//           }),
//         });
//         const result = await response.json();
//         if (!response.ok) {
//           throw new Error(`HTTP ${response.status}: Failed to submit search request`);
//         }
//         setIsPaymentModalOpen(false);
//         setIsJobOfferModalOpen(false);
//         toast.success("Search request submitted successfully");
//       } else {
//         setPaymentStatus(false);
//         toast.error("Payment failed");
//       }
//     } catch (err) {
//       console.error("Payment Submission Error:", err);
//       setError(`Failed to process payment: ${err.message}`);
//     }
//   };

//   const getStatusColor = (status) => {
//     switch (status) {
//       case "Applied":
//       case "Shortlisted":
//         return "bg-yellow-100 text-yellow-800";
//       case "Interviewed":
//         return "bg-purple-100 text-purple-800";
//       case "Rejected":
//         return "bg-red-100 text-red-800";
//       case "Offer":
//       case "Accepted":
//         return "bg-green-100 text-green-800";
//       default:
//         return "bg-gray-100 text-gray-800";
//     }
//   };

//   const renderApplicationTable = (applications, title) => (
//     <div className="mb-8">
//       <h3 className="text-lg font-semibold mb-4">{title}</h3>
//       <div className="relative overflow-x-auto rounded-lg border border-gray-200">
//         <table className="w-full text-sm text-left">
//           <thead className="text-xs uppercase bg-gray-50">
//             <tr>
//               <th className="px-6 py-3 font-medium text-gray-500">Company</th>
//               <th className="px-6 py-3 font-medium text-gray-500">Position</th>
//               <th className="px-6 py-3 font-medium text-gray-500">Date Applied</th>
//               <th className="px-6 py-3 font-medium text-gray-500">Status</th>
//               <th className="px-6 py-3 font-medium text-gray-500">Reason</th>
//               <th className="px-6 py-3 font-medium text-gray-500">Cover Letter</th>
//               <th className="px-6 py-3 font-medium text-gray-500">Resume</th>
//               <th className="px-6 py-3 font-medium text-gray-500">Availability</th>
//               <th className="px-6 py-3 font-medium text-gray-500">Open for Students</th>
//               <th className="px-6 py-3 font-medium text-gray-500">Additional Doc</th>
//             </tr>
//           </thead>
//           <tbody className="divide-y divide-gray-200">
//             {applications?.length > 0 ? (
//               applications.map((app, index) => (
//                 <tr
//                   key={index}
//                   className="bg-white hover:bg-gray-50 transition-colors"
//                 >
//                   <td className="px-6 py-4">
//                     <div>
//                       <div className="font-semibold">
//                         {app.companyId?.companyName || "N/A"}
//                       </div>
//                       <div className="text-sm text-gray-500">
//                         {app.companyAddress || "N/A"}
//                       </div>
//                     </div>
//                   </td>
//                   <td className="px-6 py-4">{app.position || "N/A"}</td>
//                   <td className="px-6 py-4">
//                     {app.createdAt ? new Date(app.createdAt).toLocaleDateString() : "N/A"}
//                   </td>
//                   <td className="px-6 py-4">
//                     <span
//                       className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(
//                         app.status
//                       )}`}
//                     >
//                       {app.status || "N/A"}
//                     </span>
//                   </td>
//                   <td className="px-6 py-4">{app.reasonForRejection || "N/A"}</td>
//                   <td className="px-6 py-4">{app.coverLetter || "N/A"}</td>
//                   <td className="px-6 py-4">{app.resume || "N/A"}</td>
//                   <td className="px-6 py-4">{app.availability || "N/A"}</td>
//                   <td className="px-6 py-4">{app.openForStudents || "N/A"}</td>
//                   <td className="px-6 py-4">{app.additionalDocument || "N/A"}</td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="10" className="px-6 py-4 text-center text-gray-500">
//                   No applications found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//         {applications?.length > 0 && applications.some(app => app.additionalQuestionResponse?.length > 0) && (
//           <div className="px-6 py-4">
//             <h4 className="text-sm font-medium text-gray-700 mb-2">Additional Questions</h4>
//             <ul className="list-disc pl-5">
//               {applications
//                 .filter(app => app.additionalQuestionResponse?.length > 0)
//                 .map((app, appIndex) =>
//                   app.additionalQuestionResponse.map((resp, respIndex) => (
//                     <li key={`${appIndex}-${respIndex}`} className="font-medium">
//                       {typeof resp === 'object' && resp !== null ? (
//                         <>
//                           <span className="font-semibold">Question: </span>{resp.question || "N/A"}
//                           <br />
//                           <span className="font-semibold">Response: </span>{resp.response || "N/A"}
//                         </>
//                       ) : (
//                         resp
//                       )}
//                     </li>
//                   ))
//                 )}
//             </ul>
//           </div>
//         )}
//       </div>
//     </div>
//   );

//   const renderJobOfferDetails = () => {
//     const seekerOffers = Array.isArray(jobOffers) ? jobOffers.filter(offer => offer.candidate?._id === selectedJobSeeker._id) : [];
//     return (
//       <div className="mb-8">
//         <h3 className="text-lg font-semibold mb-4">Job Offers</h3>
//         <button
//           onClick={() => setIsJobOfferModalOpen(true)}
//           className="mb-4 px-4 py-2 bg-[#1E3A8A] text-white rounded-md hover:bg-blue-700"
//         >
//           View Current Job Offer Details
//         </button>
//         {seekerOffers.length > 0 ? (
//           <div className="relative overflow-x-auto rounded-lg border border-gray-200">
//             <table className="w-full text-sm text-left">
//               <thead className="text-xs uppercase bg-gray-50">
//                 <tr>
//                   <th className="px-6 py-3 font-medium text-gray-500">Employer</th>
//                   <th className="px-6 py-3 font-medium text-gray-500">Amount</th>
//                   <th className="px-6 py-3 font-medium text-gray-500">Resumption Date</th>
//                   <th className="px-6 py-3 font-medium text-gray-500">Resumption Time</th>
//                   <th className="px-6 py-3 font-medium text-gray-500">Status</th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-200">
//                 {seekerOffers.map((offer, index) => (
//                   <tr key={index} className="bg-white hover:bg-gray-50 transition-colors">
//                     <td className="px-6 py-4">{offer.employer?.companyName || "N/A"}</td>
//                     <td className="px-6 py-4">{offer.amount || "N/A"}</td>
//                     <td className="px-6 py-4">{offer.resumptionDate || "N/A"}</td>
//                     <td className="px-6 py-4">{offer.resumptionTime || "N/A"}</td>
//                     <td className="px-6 py-4">
//                       <span
//                         className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(
//                           offer.status
//                         )}`}
//                       >
//                         {offer.status || "N/A"}
//                       </span>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         ) : (
//           <p className="text-gray-500">No job offers found for this job seeker</p>
//         )}
//       </div>
//     );
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedJobSeeker(null);
//   };

//   return (
//     <div className="bg-white shadow-sm rounded-lg p-6">
//       <h2 className="text-lg font-semibold text-gray-900 mb-4">Search Jobseeker</h2>
//       <div className="flex gap-4 mb-4">
//         <input
//           type="text"
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//           onKeyPress={handleKeyPress}
//           placeholder="Enter jobseeker name"
//           className="flex-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1E3A8A]"
//         />
//         <button
//           onClick={handleSearch}
//           disabled={isLoading}
//           className="px-4 py-2 bg-[#F97316] text-white rounded-md hover:bg-[#EA580C] disabled:bg-orange-300"
//         >
//           {isLoading ? "Searching..." : "Search"}
//         </button>
//       </div>
//       {error && <p className="text-red-500 mb-4">{error}</p>}
//       {isLoading && <p className="text-gray-500 mb-4">Loading...</p>}
//       {jobSeekers.length > 0 && (
//         <div className="mt-4">
//           <h3 className="text-md font-medium text-gray-700 mb-2">Search Results</h3>
//           <ul className="divide-y divide-gray-200">
//             {jobSeekers.map((jobSeeker) => (
//               <li
//                 key={jobSeeker._id}
//                 className="py-2 flex justify-between items-center"
//               >
//                 <span>{`${jobSeeker.firstName} ${jobSeeker.lastName}`}</span>
//                 <button
//                   onClick={() => {
//                     setSelectedJobSeeker(jobSeeker);
//                     setIsModalOpen(true);
//                   }}
//                   className="p-2 hover:bg-gray-100 rounded-full"
//                 >
//                   <MdBorderHorizontal className="w-4 h-4" />
//                 </button>
//               </li>
//             ))}
//           </ul>
//         </div>
//       )}
//       {/* Search History Section */}
//       <div className="mt-6">
//         <h3 className="text-md font-medium text-gray-700 mb-2">Your Search History</h3>
//         {searchHistory.length > 0 ? (
//           <ul className="divide-y divide-gray-200">
//             {searchHistory.map((history, index) => (
//               <li key={index} className="py-2">
//                 <p>
//                   <strong>Searched:</strong> {history.searchQuery} |{" "}
//                   <strong>Job Seeker:</strong>{" "}
//                   {history.jobSeekerId?.firstName} {history.jobSeekerId?.lastName} |{" "}
//                   <strong>Date:</strong>{" "}
//                   {new Date(history.timestamp).toLocaleString()}
//                 </p>
//               </li>
//             ))}
//           </ul>
//         ) : (
//           <p className="text-gray-500">No search history available</p>
//         )}
//       </div>
//       {/* Notifications Section */}
//       <div className="mt-6">
//         <h3 className="text-md font-medium text-gray-700 mb-2">Notifications</h3>
//         {notifications.length > 0 ? (
//           <ul className="divide-y divide-gray-200">
//             {notifications.map((notification, index) => (
//               <li key={index} className="py-2">
//                 <p>
//                   {notification.message} |{" "}
//                   <strong>Date:</strong>{" "}
//                   {new Date(notification.timestamp).toLocaleString()}
//                 </p>
//               </li>
//             ))}
//           </ul>
//         ) : (
//           <p className="text-gray-500">No notifications received</p>
//         )}
//       </div>
//       {isModalOpen && selectedJobSeeker && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div
//             id="job-seeker-modal"
//             className="bg-white rounded-lg p-6 max-w-4xl w-full max-h-[80vh] overflow-y-auto"
//           >
//             <div className="flex justify-between items-center mb-4">
//               <h2 className="text-xl font-semibold">
//                 {`${selectedJobSeeker.firstName} ${selectedJobSeeker.lastName}'s Details`}
//               </h2>
//               <div className="flex items-center space-x-2">
//                 <button
//                   onClick={handleDownloadPDF}
//                   disabled={isDownloading}
//                   className={`bg-[#F97316] text-white px-4 py-2 rounded hover:bg-[#EA580C] transition-colors ${
//                     isDownloading ? "opacity-50 cursor-not-allowed" : ""
//                   }`}
//                   aria-label="Download job seeker details as PDF"
//                 >
//                   {isDownloading ? "Downloading..." : "Download PDF"}
//                 </button>
//                 <button
//                   onClick={handleCloseModal}
//                   className="text-gray-500 hover:text-gray-700"
//                   aria-label="Close modal"
//                 >
//                   ✕
//                 </button>
//               </div>
//             </div>
//             <div className="space-y-6">
//               <div>
//                 <h3 className="text-lg font-semibold mb-2">Personal Information</h3>
//                 <p><strong>Email:</strong> {selectedJobSeeker.email || "N/A"}</p>
//                 <p><strong>Address:</strong> {selectedJobSeeker.address || "N/A"}</p>
//                 <p><strong>Address 2:</strong> {selectedJobSeeker.address2 || "N/A"}</p>
//                 <p><strong>Date of Birth:</strong> {selectedJobSeeker.dateOfBirth || "N/A"}</p>
//                 <p><strong>Race:</strong> {selectedJobSeeker.race || "N/A"}</p>
//                 <p><strong>Disability:</strong> {selectedJobSeeker.disability || "N/A"}</p>
//                 <p><strong>State:</strong> {selectedJobSeeker.state || "N/A"}</p>
//                 <p><strong>Local Government:</strong> {selectedJobSeeker.localGovernment || "N/A"}</p>
//                 <p><strong>Country:</strong> {selectedJobSeeker.country || "N/A"}</p>
//                 <p><strong>Gender:</strong> {selectedJobSeeker.gender || "N/A"}</p>
//                 <p><strong>Phone Number:</strong> {selectedJobSeeker.phoneNumber || "N/A"}</p>
//                 <p><strong>WhatsApp Number:</strong> {selectedJobSeeker.whatsappNumber || "N/A"}</p>
//                 {selectedJobSeeker.jobDecision === "job-changer" && (
//                   <p><strong>Job Decision Salary:</strong> {selectedJobSeeker.jobDecisionSalary || "N/A"}</p>
//                 )}
//                 <p><strong>Interested Jobs:</strong> {selectedJobSeeker.interestedJob?.join(", ") || "N/A"}</p>
//                 <p><strong>Job Choices:</strong> {selectedJobSeeker.jobChoice?.join(", ") || "N/A"}</p>
//                 <p><strong>Account Balance:</strong> {selectedJobSeeker.accountBalance || "0"}</p>
//                 <p><strong>Is Verified:</strong> {selectedJobSeeker.isVerified ? "Yes" : "No"}</p>
//                 <p><strong>Is Blacklisted:</strong> {selectedJobSeeker.isBlacklisted ? "Yes" : "No"}</p>
//                 <p><strong>Last Login:</strong> {selectedJobSeeker.lastLogin ? new Date(selectedJobSeeker.lastLogin).toLocaleString() : "N/A"}</p>
//               </div>
//               {renderApplicationTable(
//                 selectedJobSeeker.appliedJobs?.filter(
//                   (app) =>
//                     app.status?.toLowerCase() === "applied" ||
//                     app.status?.toLowerCase() === "shortlisted"
//                 ) || [],
//                 "Applied Jobs"
//               )}
//               {renderApplicationTable(
//                 selectedJobSeeker.appliedJobs?.filter(
//                   (app) => app.status?.toLowerCase() === "interviewed"
//                 ) || [],
//                 "Scheduled Jobs (Interviews)"
//               )}
//               {renderApplicationTable(
//                 selectedJobSeeker.appliedJobs?.filter(
//                   (app) => app.status?.toLowerCase() === "rejected"
//                 ) || [],
//                 "Rejected Jobs"
//               )}
//               {renderApplicationTable(
//                 selectedJobSeeker.appliedJobs?.filter(
//                   (app) =>
//                     app.status?.toLowerCase() === "offer" ||
//                     app.status?.toLowerCase() === "accepted"
//                 ) || [],
//                 "Hired Jobs"
//               )}
//               {renderJobOfferDetails()}
//             </div>
//           </div>
//         </div>
//       )}
//       {isJobOfferModalOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg p-6 max-w-md w-full">
//             <h2 className="text-xl font-semibold mb-4">Advanced Search Form</h2>
//             <form onSubmit={handleFormSubmit}>
//               <div className="mb-4">
//                 <label className="block text-sm font-medium text-gray-700">Your Name</label>
//                 <input
//                   type="text"
//                   name="searcherName"
//                   value={formData.searcherName}
//                   onChange={handleFormChange}
//                   required
//                   className="w-full p-2 border border-gray-300 rounded-md"
//                 />
//               </div>
//               <div className="mb-4">
//                 <label className="block text-sm font-medium text-gray-700">
//                   Job Seeker's Unique ID
//                 </label>
//                 <input
//                   type="text"
//                   name="jobSeekerUniqueId"
//                   value={formData.jobSeekerUniqueId}
//                   onChange={handleFormChange}
//                   required
//                   className="w-full p-2 border border-gray-300 rounded-md"
//                 />
//               </div>
//               <div className="mb-4">
//                 <label className="block text-sm font-medium text-gray-700">
//                   Why do you want to make this advanced search?
//                 </label>
//                 <textarea
//                   name="searchReason"
//                   value={formData.searchReason}
//                   onChange={handleFormChange}
//                   required
//                   className="w-full p-2 border border-gray-300 rounded-md"
//                 />
//               </div>
//               <div className="mb-4">
//                 <label className="block text-sm font-medium text-gray-700">
//                   Email to send information to
//                 </label>
//                 <input
//                   type="email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleFormChange}
//                   required
//                   className="w-full p-2 border border-gray-300 rounded-md"
//                 />
//               </div>
//               <button
//                 type="submit"
//                 className="w-full px-4 py-2 bg-[#1E3A8A] text-white rounded-md hover:bg-blue-700"
//               >
//                 Submit
//               </button>
//             </form>
//             <button
//               onClick={() => setIsJobOfferModalOpen(false)}
//               className="mt-4 text-gray-500 hover:text-gray-700"
//             >
//               Cancel
//             </button>
//           </div>
//         </div>
//       )}
//       {isPaymentModalOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg p-6 max-w-md w-full">
//             <h2 className="text-xl font-semibold mb-4">Paystack Payment</h2>
//             <p className="mb-4">Please complete the payment of ₦5000 to access job offer details.</p>
//             <button
//               onClick={handlePayment}
//               className="w-full px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
//             >
//               Pay ₦5000
//             </button>
//             <button
//               onClick={() => setIsPaymentModalOpen(false)}
//               className="mt-4 text-gray-500 hover:text-gray-700"
//             >
//               Cancel
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// JobSeekerSearch.propTypes = {
//   // Add propTypes if needed
// };

// export default JobSeekerSearch;